// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"d5663472","583":"83cb6445","983":"5515c974"}[chunkId] + ".chunk.js";
};